enum CultureEnum {
    CZ = "cs-CZ",
    SK = "sk-SK"
}

export default CultureEnum;
